import type { WaterPhaseVolumeFactorBwCalculator } from "../d";
export const waterPhaseVolumeFactorBwCalculator: WaterPhaseVolumeFactorBwCalculator =
  params => {
    const { temperatureF, inSituPressurePSIA } = params;

    // C28: =C3-60
    const Tx = temperatureF - 60;

    // C30: =1+(1.2*10^-4)*C28+(1*10^-6)*C28^2-(3.33*10^-6)*C2
    const waterVolumeFactorBBLSTB =
      1 +
      1.2 * 10 ** -4 * Tx +
      1 * 10 ** -6 * Tx ** 2 -
      3.33 * 10 ** -6 * inSituPressurePSIA;

    return {
      waterVolumeFactorBBLSTB,
      Tx
    };
  };
